import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SWOffering from "@/pages/SWOffering";

export const Route = createFileRoute("/es/servicios/software-solutions-services/validación-de-software-y-sistemas-informáticos")({
  head: () => buildRouteHead("/es/servicios/software-solutions-services/validación-de-software-y-sistemas-informáticos"),
  component: SWOffering,
});

